<template>
  <v-app id="inspire" >
      <router-view/>
  </v-app>
</template>

<script>
  export default {
    props: {
      source: String,
    },
    data: () => ({
      drawer: null      
    }),
    created () {
      this.$vuetify.theme.dark = true
      Object.keys(process.env).map(link=>{
        if(this.$config[link])
          console.log(link+': '+ this.$config[link])
        else
          console.log(link+': '+process.env[link])
      })    
      //vue dragula configuration  
      
      
    }
    
     
  }
</script>
